import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fromConsignmentItemResponseV3 } from '../models/mapper'
import { ConsignmentItem } from '../models/types'
import { fetchConsignmentItemsV3 } from './http'

export async function fetchConsignmentItems(
  params: { consignmentId: number; houseConsignmentId?: number },
  opts?: { signal?: AbortSignal },
): Promise<ConsignmentItem[]> {
  const responses = await fetchConsignmentItemsV3(params, opts)
  return responses.map((response, index) => fromConsignmentItemResponseV3(response, index))
}

export function useFetchConsignmentItems(params: { consignmentId: number | null; houseConsignmentId?: number }) {
  return useQuery({
    queryKey: QueryKeys.consignmentItem.all(params),
    queryFn: ({ signal }) => fetchConsignmentItems({
      consignmentId: params.consignmentId as number,
      houseConsignmentId: params.houseConsignmentId,
    }, { signal }),
    enabled: !!params.consignmentId,
  })
}
